/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user-fav': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M17.476 11.58l-2.703-.392-1.207-2.446a.402.402 0 00-.722 0l-1.207 2.446-.252.036a6.687 6.687 0 00-4.592-1.797h-.012c-1.837.004-3.54.718-4.804 2.018C.697 12.76-.003 14.552 0 16.496a.396.396 0 00.401.4l9.805-.019a.399.399 0 00.58.409l2.415-1.271 2.414 1.27a.402.402 0 00.586-.425l-.462-2.69 1.953-1.904a.403.403 0 00-.216-.686zm-7.134 4.496l-9.532.02c.084-1.576.694-3.015 1.74-4.086a5.848 5.848 0 014.231-1.772h.012a5.928 5.928 0 013.525 1.146l-1.384.2a.4.4 0 00-.324.274.405.405 0 00.1.412l1.953 1.905-.321 1.901zm4.688-2.334a.405.405 0 00-.117.357l.361 2.097-1.884-.99a.396.396 0 00-.19-.044.446.446 0 00-.188.044l-1.884.99.36-2.097a.398.398 0 00-.115-.357l-1.524-1.484 2.105-.304a.392.392 0 00.3-.22l.943-1.91.942 1.91c.059.117.17.2.301.22l2.105.304-1.515 1.484zM6.788 8.477a4.239 4.239 0 100-8.477 4.239 4.239 0 000 8.477zm0-7.675a3.436 3.436 0 110 6.873 3.436 3.436 0 010-6.873z" _fill="#1C3B8D"/>'
  }
})
